import React from 'react';
import {Row, Col} from 'antd';
import {hashHistory,} from 'react-router';
import {TableView} from '../../components';
import moment from 'moment';
import '../print/table.css';

class ShipRequestPrintBatch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['送货单打印'],
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: {},
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            value: '',
            num: 0,
            mapRows: [],
            listRows: [],
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }


    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }


    /*获取列表数据*/
    initData() {
        const data = JSON.parse(window.sessionStorage.getItem('shipRequestBatch'));
        const linkAddress = window.sessionStorage.getItem('shipRequestBatchAddress');
        // 1. 分组汇总计算
        const groupedData = data.reduce((acc, item) => {
            if (!acc[item.itemNum]) {
                acc[item.itemNum] = {
                    items: [],
                    total: 0,
                    description: item.itemDesc // 保留物料描述
                };
            }
            acc[item.itemNum].items.push(item);
            acc[item.itemNum].total += item.quantity;
            return acc;
        }, {});
        // 2. 插入汇总行并展平
        const tableData = Object.keys(groupedData)
            .sort((a, b) => a.localeCompare(b)) // 按物料号排序
            .flatMap(itemNum => {
                const group = groupedData[itemNum];
                return [
                    ...group.items, // 原始明细行
                    {
                        id: `summary-${itemNum}`,
                        itemNum,
                        itemDesc: group.description,
                        deliveryId: '小计',
                        quantity: group.total,
                        isSummaryRow: true // 汇总行标记
                    }
                ];
            });

        var mapRows = [];
        // 不需要小计
        // var result = this.split_array(tableData, 9999);
        var result = this.split_array(data, 9999);
        for (var x = 0; x < result.length; x++) {
            result[x].key = x + 1
        }
        for (let j = 0; j < result.length; j++) {
            var totalcount = 0;
            var receiptCust = '';
            var salesUnitName = '';
            var printBatchId = '';
            var printDate = '';
            for (let z = 0; z < result[j].length; z++) {
                if (result[j][z].deliveryId != '小计') {
                    totalcount = totalcount + result[j][z].quantity;
                }
                if (z == 0) {
                    receiptCust = result[j][z].receiptCust;
                    salesUnitName = result[j][z].salesUnitName;
                    printBatchId = result[j][z].printBatchId;
                    printDate = result[j][z].printDate;
                }
            }
            mapRows[j] = {
                list: result[j],
                total: result[j].length,
                key: j,
                receiptCust: receiptCust,
                salesUnitName: salesUnitName,
                printBatchId: printBatchId,
                printDate: printDate
            };
            result[j].push({id: 99999999, isSummaryRow: true, deliveryId: '合计:', quantity: totalcount});
        }
        var num = Math.ceil(data.length / 10);
        this.setState({
            rows: data,
            resultData: data,
            num: num,
            mapRows: mapRows,
            listRows: result,
            linkAddress: linkAddress
        }, () => {
        });
    }

    split_array(arr, len) {
        var a_len = arr.length;
        var result = [];
        for (var i = 0; i < a_len; i += len) {
            result.push(arr.slice(i, i + len));
        }
        return result;
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            rows,
            total,
            searchObj,
            mapRows,
            userData,
            linkAddress
        } = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: '15%',
                    render: (text, record, index) => {
                        if (record.isSummaryRow) {
                            return (<span
                                style={{fontWeight: 'bold'}}>{text}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: '物料名称',
                    dataIndex: 'itemDesc',
                    width: '42%',
                    render: (text, record, index) => {
                        if (record.isSummaryRow) {
                            return (<span
                                style={{fontWeight: 'bold'}}>{text}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: '数量',
                    dataIndex: 'quantity',
                    width: '6%',
                    render: (text, record, index) => {
                        if (record.isSummaryRow) {
                            return (<span
                                style={{fontWeight: 'bold'}}>{text}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: '结算对应号',
                    dataIndex: 'closeHomologous',
                    width: '13%'
                },
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber',
                    width: '13%'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId',
                    width: '11%',
                    render: (text, record, index) => {
                        if (record.isSummaryRow) {
                            return (<span
                                style={{fontWeight: 'bold'}}>{text}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                }
            ],
            paginationHide: true,
            rows
        };
        const h1 = {width: '100%', textAlign: 'center', color: '#000', marginTop: 15, fontSize: '20px'}
        const h2 = {width: '100%', textAlign: 'center', color: '#000', marginTop: 0, fontSize: '18px'}
        const top = {width: '100%', textAlign: 'center', position: 'relative', color: '#000'}
        const printDate = moment(new Date()).format('YYYY/MM/DD');
        const dom = (mapRows || []).map(function (ele, key) {
            return <div style={{padding: '5px', color: '#000'}} key={ele.key}>
                <p style={top}>
                    <span style={{
                        position: 'absolute',
                        left: 0,
                        color: '#000'
                    }}>送货批次：{ele.printBatchId}</span>
                </p>
                <p style={top}>
                    <span style={{
                        position: 'absolute',
                        right: 0,
                        color: '#000'
                    }}>打印时间：{printDate}</span>
                </p>
                <p style={h1}>浙江天正电气股份有限公司</p>
                <p style={h2}>送货单</p>
                <div className="dms-table-box" style={{lineHeight: '5px', marginTop: 0}}>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={20}>
                            <label>送货日期：{ele.printDate ? moment(ele.printDate).format('YYYY-MM-DD HH:mm:ss') : ''}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={20}>
                            <label>客户名称：{ele.salesUnitName}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={20}>
                            <label>地址电话：{ele.receiptCust}</label>
                        </Col>
                    </Row>
                    <div style={{display: "block"}}>
                        <div className="dms-table-box yourClass">
                            <TableView {...tableViewProps} rows={ele.list}/>
                        </div>
                    </div>
                </div>
                <div style={{display: "block"}}>
                    <p><span>操作员：{userData.userName}</span>&emsp;<span>出库：____________</span>&emsp;
                        <span>客户签名：____________</span>
                    </p>
                    <p><span>联系方式：{linkAddress}</span>
                    </p>
                </div>
                <div style={{pageBreakAfter: 'always'}}></div>
            </div>

        })
        return (
            <div>
                {dom}
            </div>
        )
    }
}

export default ShipRequestPrintBatch;


// WEBPACK FOOTER //
// ./src/routes/shipRequest/shipRequestPrintBatch.js